module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Case Description")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('div', [(_vm.$can('view', 'cases-detail-case-description-tab')) ? _c('v-layout', {
    attrs: {
      "id": "case-description-tab",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('CaseUserCreatedDataTable', {
    attrs: {
      "caseid": _vm.caseData.id,
      "caseModel": _vm.caseData
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('CaseCrewDataTable', {
    attrs: {
      "case": _vm.caseData,
      "caseid": _vm.caseData.id
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.caseData.plans_id > 0) ? _c('CasePlanDataTable', {
    attrs: {
      "plansid": _vm.caseData.plans_id,
      "casesid": _vm.id
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'vendor')) ? _c('v-layout', {
    attrs: {
      "id": "case-description-tab",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake Dates")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n                        N/A (preplan)\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm.moment(_vm.caseData.wake_start).format('YYYY-MM-DD')) + " - " + _vm._s(_vm.caseData.wake_end ? _vm.moment(_vm.caseData.wake_end).format('YYYY-MM-DD') : 'not set') + "\n                      ")])])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Case Manager")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab1),
      callback: function($$v) {
        _vm.selectedTab1 = $$v
      },
      expression: "selectedTab1"
    }
  }, [(_vm.$can('view', 'cases-detail-plan-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#plan-tab"
    }
  }, [_vm._v("\n            Plan\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-client-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#client-tab"
    }
  }, [_vm._v("\n            Client\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-services-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#services-tab"
    }
  }, [_vm._v("\n            Vendors\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-embalming-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#embalming-tab"
    }
  }, [_vm._v("\n            Embalming\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-agreement-feedback-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#agreement-feedback-tab"
    }
  }, [_vm._v("\n            Agreement & Feedback\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-plan-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "plan-tab"
    }
  }, [_c('SelectPlanAndVendors', {
    attrs: {
      "caseModel": _vm.caseData,
      "case-id": _vm.caseData.id,
      "editable": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-client-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "client-tab"
    }
  }, [_c('CaseClientDataTable', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-services-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "services-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseServicesDataTable', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-embalming-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "embalming-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', [_vm._v("\n                    Photo\n                  ")]), _vm._v(" "), (_vm.caseData.embalmers_photo) ? _c('v-img', {
    attrs: {
      "aspect-ratio": "1",
      "src": _vm.caseData.embalmers_photo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h3', [_vm._v("\n                    Remarks\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.caseData.embalmers_remarks) + "\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-agreement-feedback-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "agreement-feedback-tab"
    }
  }, [_c('CaseAgreementFeedback', {
    attrs: {
      "caseModel": _vm.caseData,
      "selectedTab1": _vm.selectedTab1
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Finance/Admin")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [(_vm.caseData && _vm.caseData.id) ? _c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab2),
      callback: function($$v) {
        _vm.selectedTab2 = $$v
      },
      expression: "selectedTab2"
    }
  }, [(_vm.$can('view', 'cases-detail-pdf-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#pdf-tab"
    }
  }, [_vm._v("\n            Vendor Invoices\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-log-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#actions-log-tab"
    }
  }, [_vm._v("\n            Actions Log\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-deposits-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#deposits-tab"
    }
  }, [_vm._v("\n            Deposit\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-commissions-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#commissions-tab"
    }
  }, [_vm._v("\n            Commissions\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-chat-tab')) ? _c('v-tab', {
    attrs: {
      "href": "#chat-tab"
    }
  }, [_vm._v("\n            Chat\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-pdf-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "pdf-tab"
    }
  }, [(_vm.$can('view', 'cases-detail-invoices')) ? _c('v-card', [_c('v-card-text', [_c('CaseInvoicesDataTable', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-actions-log-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "actions-log-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseActionsLogDataTable', {
    attrs: {
      "casesid": _vm.caseData.id,
      "is-personal": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-deposits-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "deposits-tab"
    }
  }, [_c('CaseDeposit', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-commissions-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "commissions-tab"
    }
  }, [_c('CaseCommissions', {
    attrs: {
      "caseModel": _vm.caseData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$can('view', 'cases-detail-chat-tab')) ? _c('v-tab-item', {
    attrs: {
      "id": "chat-tab"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('CaseFormsChat', {
    attrs: {
      "casesid": _vm.caseData.id
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d1466ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/CasesDetail.vue
// module id = 959
// module chunks = 1